import { goodsSkuPage,brandList } from "@/api/goods/goods"
import { mapGetters } from "vuex"
import { relevanceinfo, goodsCategoryInfo,tree } from "@/api/goods/goodscategory"
import { addCollect, deleteCollect, isCollect } from "@/api/goods/goods_collect"
import { getArea,getCity } from "@/api/address"
import { jobList, jobDetail} from "@/api/cms/job"
import { adList } from "@/api/website"

export default {
    data: () => {
        return {
            cargoList: [],
            // attributeList: [], // 属性列表
            // brandInitialList: [],
            // currentInitial: "", // 当前选择品牌分区
            // choosedBrand: "", // 已选择的品牌,
            // hasChoosedAttrs: false, // 忆选择的属性
            total: 0,
            keyword: "",
            currentPage: 1,
            pageSize: 12,
            filters: {
                site_id: 0,
                // category_id: 0,
                order: "id",
                sort: "desc",
				area_id:0,
				province_id:0,
				city_id:0,
				// type:0,
				working:0,
				education:0,
				min_price: "",
				max_price: "",
            },
            loading: true,
            // whetherCollection: 0,
			categoryList:[],
			priceList:[
				{
					min_price:'',
					max_price:'',
					name:'不限'
				},
				{
					min_price:0,
					max_price:5000,
					name:'5千'
				},
				{
					min_price:5000,
					max_price:10000,
					name:'5千-1万'
				},
				{
					min_price:10000,
					max_price:20000,
					name:'1万-2万'
				},
				{
					min_price:20000,
					max_price:50000,
					name:'2万-5万'
				},
				{
					min_price:50000,
					max_price:99999999,
					name:'5万以上'
				},
			],
			workingList:[
				//0不限制 1在校生应届生 2 1-3年 3,3-5年,4,5-10年,5,10年以上
				'不限制',
				'在校生应届生',
				'1-3年',
				'3-5年',
				'5-10年',
				'10年以上',
			],
			educationList:[
				//0学历要求 默认0 |0不限制|1初中|2高中\中职\中专|3大专|4本科|5硕士|6博士
				'不限制',
				'初中',
				'高中\中职\中专',
				'大专',
				'本科',
				'硕士',
				'博士',
			],
			adList:[]
			// area:{
			// 	province:[],
			// 	city:[]
			// },
        }
    },
    created() {
    },
	mounted(){
		// console.log('mounted');
		this.keyword = this.$route.query.keyword || ""
		this.filters.area_id = this.$route.query.area_id || 0
		this.getAdList();
		// this.load()
	},
    computed: {
        ...mapGetters(["defaultGoodsImage","area"])
    },
    methods: {
		load(){
			this.getGoodsList()
		},
		/**
		 * 广告
		 */
		getAdList() {
			console.log(33333333)
		   
		    adList({ keyword: "PC_JOB_INDEX_LIST" })
		        .then(res => {
					console.log(22222222222222,res)
		            this.adList = res.data.adv_list
		            for (let i = 0; i < this.adList.length; i++) {
		                if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
		            }
		        })
		        .catch(err => {
					console.log(22222222222222,res)
		        })
		},
        /**
         * 商品分类搜索
         */
        getGoodsList() {
			
            const params = {
                page: this.currentPage,
                page_size: this.pageSize,
                site_id: this.filters.siteId,
                keyword: this.keyword,
                // attr: currentArr.length > 0 ? JSON.stringify(currentArr) : "",
                ...this.filters
            }
            jobList(params || {})
                .then(res => {
                    const { count, page_count, list } = res.data
                    this.total = count
                    this.cargoList = list
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
        },

        handlePageSizeChange(size) {
            this.pageSize = size
            this.getGoodsList()
        },
        handleCurrentPageChange(page) {
            this.currentPage = page
            this.getGoodsList()
        },
        handlePriceRange() {
            this.getGoodsList()
        },
        handleChangeInitial(initial) {
            this.currentInitial = initial
        },
        changeSort(type) {
            if (this.filters.order === type) {
                this.$set(this.filters, "sort", this.filters.sort === "desc" ? "asc" : "desc")
            } else {
                this.$set(this.filters, "order", type)
                this.$set(this.filters, "sort", "desc")
            }
            this.getGoodsList()
        },
		getBrandList(){
			brandList({
				// pid:1
				page_size:30
			})
			.then(res => {
				if (res.code == 0 && res.data) {
					
					this.brandList = res.data.list;
				}
			})
			.catch(err => {
				this.$message.error(err.message);
			});
		},
		contacts(row){
			let str  = (row.tel || row.phone || row.email || row.site.telephone || row.site.mobile || row.site.email || '')
			if(str){
				return str.substr(0,3)+"****"+str.substr(7);
			}
			return '暂无';
		}
    },
    watch: {
        is_free_shipping: function (val) {
            this.filters.is_free_shipping = val ? 1 : ""
            this.getGoodsList()
        },
        is_own: function (val) {
            this.filters.is_own = val ? 1 : ""
            this.getGoodsList()
        },
        $route: function (curr) {
			this.keyword = curr.query.keyword
			
            if (curr.query.category_id != undefined) {
                this.catewords = ""
                this.currentPage = 1
                this.filters.category_id = curr.query.category_id || ""
                this.filters.category_level = curr.query.level || ""
                // this.filters.brand_id = curr.query.brand_id || ""
            }
        },
		keyword:function (val) {
			this.load()
        },
		filters:{
			handler(newName, oldName) {
				this.load()
			},
			immediate: true,
			deep:true
		}
    }
}
